import React, { useState, useEffect, useRef } from "react";
import Footer from "@/kyna/includes/Footer";
import HeaderNav from "@/kyna/includes/HeaderNav";
import Link from "next/link";
import Image from "next/image";
import KNModal from "@/kyna/ui/modal/KNModal";

import NPCLogo from "../../../public/assets/img/npc-logo.png";
import CORImage from "../../../public/assets/img/NPC-Registration-Cert-2026.jpg";

const PrivacyPolicy = () => {
  const [isOpenModal, setIsOpenModal] = useState(false);
  return (
    <>
      {/* MAIN NAVIGATION */}
      <HeaderNav />

      {/* PRIVACY NOTICE */}
      <section className="max-w-screen-xl mx-auto lg:mt-44 mt-36 md:px-10 sm:px-8 px-6">
        <div className="grid">
          <h1 className="md:text-4xl text-3xl leading-tight text-blue text-center mb-12">
            Privacy Notice
          </h1>
          <div className="flex items-center gap-8 flex-wrap mb-10">
            <div className="max-w-[150px]">
              <Image src={NPCLogo} alt="National Privacy Commission" />
            </div>
            <button
              onClick={() => setIsOpenModal(true)}
              className="text-blue text-lg underline"
            >
              NPC Registration No. PIC-000-146-2026
            </button>
          </div>
          <div className="">
            <p className="leading-normal pb-5">
              <b>
                This privacy notice is being given to all persons who visit the
                PHILIPPINE MENTAL HEALTH ASSOCIATION, INC. (“PMHA” or “our” or
                “we” or “us”) offices or digital sites, meet with our personnel,
                or visit or participate in our events or activities. This notice
                is in compliance with the requirements of the Data Privacy Act
                of 2012 (DPA) and its Implementing Rules and Regulations.
              </b>
            </p>
            <p className="leading-normal pb-5">
              When you visit our offices or digital sites, meet with our
              personnel, or visit or participate in our events or activities ,
              we may collect and process your personal data, such as but not
              limited to your name and contact details. For example, we may ask
              you to sign in a visitor's log, register for an event, or provide
              us with your business card or an identification card. Also, our
              office premises are monitored by a CCTV system, and we will record
              your comings and goings.
            </p>
            <p className="leading-normal pb-5">
              We collect and process this data to perform our functions as a
              professional organization, to be able to comply with requests, to
              ensure the security of our premises and personnel, and for other
              legitimate purposes. Generally, we do not share this data with any
              person outside our organization, but may do so when permitted by
              law, or when it is needed to enable us to perform our services, or
              to legitimately protect our interests. In this case, we will take
              reasonable steps to ensure that those recipients only process your
              personal data for the specific purpose for which it was collected
              by us and will protect the privacy of your personal data.
            </p>
            <p className="leading-normal pb-5">
              We will retain the data only for so long as necessary to achieve
              the purposes for which the data was collected. We use standard
              manual and electronic methods of processing the data.
            </p>
            <p className="leading-normal pb-5">
              By providing us with or making available to us your personal data,
              visiting our offices or digital sites, utilizing our services, or
              visiting or participating in our events and activities, you agree
              and consent to our collecting, using, disclosing, sharing and
              otherwise processing that data for the purposes specified here.
              This consent supplements and does not supersede or replace any
              other consent you have also provided to us in respect of your
              personal data, or the existence of a lawful basis for that data's
              collection and processing.
            </p>
            <p className="leading-normal pb-5">
              If you provide us with personal data of other individuals, by
              doing so, you also represent and warrant to us that you have the
              right and authority to provide that data and that you have
              informed the relevant individuals of, and that they consent to,
              the terms of this Privacy Notice.
            </p>
            <p className="leading-normal pb-5">
              To the extent that our website and other digital presence contain
              links to sites operated by third parties, including other
              organizations, those linked websites are not controlled by us and
              we are not responsible for the data and privacy practices of the
              site operators. We encourage you to review the privacy policies
              posted on these third-party websites.
            </p>
            <p className="leading-normal pb-5">
              The DPA specifies the rights of a data subject, and these are: the
              right to be informed regarding certain matters; the right to
              object to the processing of data; the right to reasonable access
              to certain information; the right to rectification of inaccuracy
              or error in your data; the right to block or remove data under
              certain circumstances; the right to damages in case you suffer an
              injury due to inaccurate, incomplete, outdated, false, unlawfully
              obtained or unauthorized use of data; transmissibility of your
              rights as a data subject; the right to data portability; and the
              right to lodge a complaint with the Philippine National Privacy
              Commission, if circumstances permit this.
            </p>
            <p className="leading-normal pb-5">
              If you do not wish to provide your personal data pursuant to our
              requests or under the conditions specified herein, we may not be
              able to permit entry in our premises, use of our sites or
              participation in our events or activities.
            </p>
            <p className="leading-normal pb-5">
              From time to time, we may review the terms and conditions in this
              Privacy Notice. If we make changes that affect the way we use your
              personal data, we will notify you by posting a revised statement
              on our Website and in a prominent area within our offices.
            </p>
            <p className="leading-normal pb-5">
              If you have questions, comments, or complaints relating to the
              handling of your personal data, please feel free to{" "}
              <Link href="/contact">
                <a className="text-blue underline">contact us</a>
              </Link>
              .
            </p>
          </div>
        </div>
      </section>

      <KNModal
        title={""}
        no_header={true}
        bodyClassPad={"!p-0"}
        isOpen={isOpenModal}
        noFooter={true}
        bodyClass={"cert-modal !max-w-5xl mt-10"}
        onOpen={() => {}}
        closeModal={() => {
          setIsOpenModal(false);
        }}
        body={<Image src={CORImage} alt="Certification of Registration" />}
      />

      {/* FOOTER */}
      <Footer />
    </>
  );
};

export default PrivacyPolicy;
